<template>
  <AntSelect
    v-bind="$attrs"
    style="width: 100%"
    :label="label"
    :value="filteredValue"
    :options="selectOptions"
    mode="multiple"
    optionFilterProp="label"
    showSearch
    :disabled="disabled"
    @change="onSelectChange"
  />
</template>

<script>
import { capitalize } from 'lodash'

import {
  Select as AntSelect,
} from 'ant-design-vue'
import { computed } from 'vue'

export default {
  name: 'PlatformDocSelect',
  components: {
    AntSelect,
  },
  props: {
    type: String,
    value: Array,
    disabled: {
      type: Boolean,
      default: false,
    },
    options: Array,
    onChange: Function,
  },
  setup(props) {
    const label = capitalize(props.type)
    const selectOptions = computed(() => (props.type.startsWith('excluded') ? props.options : [{ label: 'ALL', value: 'ALL' }, ...props.options]))
    const selectOptionsMap = computed(() => Object.fromEntries(selectOptions.value.map(o => [o.value, o.label])))

    const filteredValue = computed(() => (props.value // eslint-disable-line no-nested-ternary
      ? props.value.filter(v => selectOptionsMap.value[v])
      : props.type.startsWith('excluded') ? [] : ['ALL']))

    const onSelectChange = (selectedVals, e) => {
      console.log('onChange', selectedVals, e)

      let value = selectedVals
      if (selectedVals.length > 1 && selectedVals[0] === 'ALL') {
        value.splice(0, 1)
      } else if (!selectedVals.length || (selectedVals.length >= 1 && selectedVals[selectedVals.length - 1] === 'ALL')) {
        value = null
      }

      console.log('PlatformDocSelect value', value)
      props.onChange(value ? value.sort() : value)
    }

    return {
      label,
      filteredValue,
      selectOptions,
      onSelectChange,
    }
  },
}
</script>

<style scoped>

</style>
